import React from 'react';
import { Tabs } from 'antd';
import GetToKnowSection from './AboutSettingComponent/getToKnowSection';
import TestimonialHeadSection from './AboutSettingComponent/TestimonialHeadSection';
import TestimonialCrousalSection from './AboutSettingComponent/TestimonialCrousalSection';
import WhyToChooseUsListSection from './AboutSettingComponent/WhyToChooseUsListSection';
import WhyToChooseUsTitleSection from './AboutSettingComponent/WhyToChooseUsTitleSection';
import TextEditor from '../Helper/TexEditor';
import Test from './Test';

export default function AboutSetting() {
  
const { TabPane } = Tabs;
function callback(key) {
//   console.log(key);
}
  return (
    <div>
        <Tabs defaultActiveKey="1" onChange={callback} size="large" centered>
    <TabPane tab="Get To Know Section" key="1">
     <GetToKnowSection/>
      
    </TabPane>
    <TabPane tab="Testimonial Section" key="2">
    <TestimonialHeadSection/>
    <TestimonialCrousalSection/>
    </TabPane>

    <TabPane tab="Why To Choose US Setting" key="3">
          <WhyToChooseUsTitleSection/>
          <br/>
          <WhyToChooseUsListSection/>
        </TabPane>
    
    
  </Tabs>
    </div>
  )
}
